import ClientForm from "../../../Client/ClientForm";
export const ConfirmationFormSection = ({ initialData, handleSubmit, handleCancel, handleError }) => {
    return (
        <div className="confirmation-modal-content">
            <p className="legal-notice">
                Por requisitos legales, es necesario confirmar los datos de
                facturación del cliente. Por favor, verifique que todos los datos
                son correctos antes de continuar.
            </p>

            <ClientForm
                initialData={initialData}
                handleSubmit={handleSubmit}
                handleCancel={handleCancel}
                handleError={handleError}
            />
        </div>
    )
}